export const multipleFacility =
{
    MULTI_FACILITY_ORDER_LABEL: 'Multi Facility Order',
    MULTI_FACILITY_TABLE_ID: 'wcmultifacilitysummarytd',
    MULTI_FACILITY_WAREHOUSE_ID: 'wcmultifacilitydetailtd',
    WAVE_ID: 'waveId',
    MULTI_FACILITY_HEADING:'Multiple Facility Warehouse',
    FIELDS: {
        FACILITY: 'facility',  
        PERCENTAGE_OF_WAVE: 'PercentageOfWave',  
        QTY_ALLOCATED: 'QtyAllocated',  
        TOTAL_WAVE_QTY: 'TotalWaveQty',  
        PALLET_ALLOCATED: 'PalletAllocated', 
        TOTAL_PALLETS: 'TotalPallets', 
        ROW_INDEX: 'rIdx',  
        WAVE_KEY: 'waveKey',
        IS_PROCESSING_FACILITY: 'IsProcessFacility'
    },
    OPERATIONS: {
        EQUAL: '=',
        AND: 'AND',
        GREATER_THAN: '>'
    },
    WAREHOUSE_DETAILS: 'Warehouse Details',
    TABLE_MODES : {
        VIEW: 'V',
    },
    SET_UNSET_RESPONSEKEYS: {
        STATUS_CODE: 'statusCode',
        STATUS_MESSAGE: 'statusMessage',
        ERROR_MESSAGE: 'errMsg',
    },
    ERR_MES_NO_WAREHOUSE_FOUND: 'msg_no_warehouse_found',
    COLUMN_NAMES: {
        MOVABLE_UNIT: 'movUnit',
        TRANSFER_TICKET: 'transTicket'
    }
};

export const shipmentOrder =
{
    COLUMN_NAMES: {
        ORDER_ID: 'orderId',
        SKU_NAME: 'SKU',
        AVAILABLE_QTY: 'Quantity',
        SO_LINE_NO: 'soLineNo',
    },
    MESSAGE: {
        NO_DETAIL_SELECTED_ALERT_MES: 'msg_sel_detail',
        NO_ROW_SELECTED_ALERT_MES: 'msg_no_row_selected',
        POPULATE_CONFIRM_MES: 'msg_conf_pop',
        POPULATE_SUCCESS_MES: 'pop_act_succ',
        CLICK_CELL_TO_COPY_VALUE: 'msg_clik_cell_to_copy_value',
        WARN_MES_CANT_COPY_FEILD: 'msg_cant_copy_field',
        COLUMN_COPY: 'msg_copy_colmn',
        TO_ALL_ROWS: 'msg_to_all_rows',
        OVERWRITE_DATA: 'msg_overwrt',
        SAVE_SUCCESS: 'msg_save_succ'
    },
    POPULATE_FIELDS: {
        TABLE_NAME: 'tableName',
        COLUMN_NAME: 'columnName',
        COPY_FROM_KEY1: 'copyFromKey1',
        COPY_FROM_KEY2: 'copyFromKey2',
        SEARCH_CRITERIA: 'searchCriteria'
    },
    PAGE_TITLE: 'Populate Pick Detail',
    POPULATE_EVENT_TYPE: 'populate',
    POPULATE_TABLE_ID: 'POPULATEADJTD',
    TABLE_MODES: {
        VIEW: 'V',
    },
    POPULATE_API_URL: `api/outbound/populatepickdetail`
}

export const shipmentReference = {
    MBOL_CARRIER_KEY: 'carrierKey'
}
export const WAVE_CONTROL = {
    GENERATE_LOAD_PLAN: 'WaveBuildLoad',
    GENERATE_MBOL: 'WaveBuildMBOL',
    NO_OF_ORDERS: 'noOfOrderNoLoad',
    LOAD_PLAN : 'loadplan',
    TYPE: 'type',
    OPERATIONS: {
        EQUAL: '=',
        AND: 'AND',
        GREATER_THAN: '>'
    }
};


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/outbound/outbound-constants.ts